import { IntegrationExportSettingItem } from './types';

export const initialConfig: IntegrationExportSettingItem = {
  ignoreGlobalBlockList: false,
  ignoreUnsubscribeList: false,
  ignoreCommunityBounceList: true,
  ignoreDuplicateLeadsInOtherCampaign: false,
};

export const configLabels: Record<keyof IntegrationExportSettingItem, string> =
  {
    ignoreGlobalBlockList:
      'Import Leads Even If They Are in The Global Block List',
    ignoreUnsubscribeList:
      'Import Leads Even If They Are In The Unsubscribe List',
    ignoreCommunityBounceList:
      'Import Leads Even If They Bounced Across Our Entire Userbase',
    ignoreDuplicateLeadsInOtherCampaign:
      'Ignore The Leads That Exist In Another Campaign',
  };

//   "fields": [
//     "EMAIL_BUSINESS",
//     "LINKEDIN",
//     "FIRSTNAME",
//     "LASTNAME",
//     "LOCATION",
//     "WEBSITE",
//     "MOBILE_PHONE",
// ]

// [
//   "FIRSTNAME",
//   "LASTNAME",
//   "MOBILE_PHONE",
//   "HOME_PHONE",
//   "LOCATION",
//   "LINKEDIN"
// ]
